import type { Block, Inline, Text } from '@contentful/rich-text-types';

export const generateId = (text: string) => text.toLowerCase().replace(/\s+/g, '-').replace('?', '').replace(':', '');

export const extractTableItems = (headings: Block[], refs: any[]): { label: string; id: string }[] => {
  const extractedItems: { label: string; id: string }[] = [];

  const extractContent = (content: Array<Block | Inline | Text>) => {
    for (const item of content) {
      if (item.nodeType === 'text') {
        const label = item.value.trim();
        const id = generateId(label);
        extractedItems.push({ label, id });
      } else if (item.nodeType === 'embedded-entry-block') {
        const id = item.data.target.sys.id;
        const label = refs.find(x => x.contentful_id === id)?.tocHeading;
        extractedItems.push({ label, id });
      } else if ('content' in item) {
        extractContent(item.content);
      }
    }
  };

  extractContent(headings);

  return extractedItems;
};
